import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./style.css";
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";


export const Contact = () => {
    const { t } = useTranslation();
    const form = useRef(null);


    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll('.contact-border');
            elements.forEach(e => {
                const rect = e.getBoundingClientRect();
                if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                    e.classList.add('in-view');
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm(
            'service_avjh2ws',
            'template_3sxoptj',
            form.current,
            'G_GFIiShl_BuU3IBw')
            .then(() => {
                toast.success(t('messageSent'), {
                    position: "bottom-center",
                    autoClose: 3000,
                    theme: "colored",
                });
            }).catch(() => {
                toast.error(t('messageFailed'), {
                    position: "bottom-center",
                    autoClose: 4000,
                    theme: "colored",
                });
            });
        e.target.reset();
    };

    return (
        <>
            <div className="contact">
                <div className="activity-header">
                    <h2>{t('navBar.home')}  <span>/ {t('navBar.contact')} </span></h2>

                </div>
                <div className="contact-me">
                    <form className="contact-form" ref={form} onSubmit={sendEmail}>
                        <h2>{t('contact.yourMessegeMe')}</h2>
                        <div className="input-box">
                            <div className="input-field">
                                <input
                                    type="text"
                                    id="user_name"
                                    name="user_name"
                                    placeholder={t('contact.name')}
                                    required
                                />
                                <span className="focus"></span>
                            </div>
                            <div className="input-field">
                                <input
                                    type="email"
                                    id="user_email"
                                    name="user_email"
                                    placeholder={t('contact.officeMail')}
                                    required
                                />
                                <span className="focus"></span>
                            </div>
                        </div>
                        <div className="textarea-field">
                            <textarea
                                id="message"
                                name="message"
                                cols="30"
                                rows="10"
                                placeholder={t('contact.message')}
                                required
                            />
                            <span className="focus"></span>
                        </div>
                        <div>
                            <button type="submit" className="contact-btn">{t('contact.send')}</button>
                        </div>
                    </form>
                    <div className="contact-info">
                        <div className="contact-border">
                            <div className="contact-content">
                                <div className="contact-icon"><FaPhone /></div>
                                <h6 className="contact-title">{t('contact.officePhone')}</h6>
                            </div>
                            <p className="contact-p">{t('phoneNumberOffice')}</p>
                        </div>
                        <div className="contact-border">
                            <div className="contact-content">
                                <div className="contact-icon"><IoMdMail /></div>
                                <h6 className="contact-title">{t('contact.officeMail')}</h6>
                            </div>
                            <p className="contact-p">{t('mail')}</p>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    );
};
